
import './modules/register-service-worker';
import { branchBar } from '@crasman/branch-bar';
branchBar.init();// See https://www.npmjs.com/package/@crasman/branch-bar for settings

import Header from './modules/veho/header';
import Footer from './modules/veho/footer';
import MobileNavigation from './modules/veho/mobile-navigation';
import {PredictingInputField} from './modules/veho/predicting-input-field';
import modalInit from './modules/veho/modal';
import ExtraInfoDropdown from './modules/veho/extrainfo-dropdown';
import webSalesTriggers from './modules/veho/websales-triggers';

Header.init();
Footer.init();
MobileNavigation.init();
PredictingInputField.init();
modalInit();
ExtraInfoDropdown.init();
webSalesTriggers.init();

import('./modules/multiselect' as any).then(multiselect => multiselect.default.init());

if (document.querySelector('#vehicle-search-form')) {
  import('./modules/vehicle-search' as any).then(vehicleSearch => vehicleSearch.default.init());
}

if (document.querySelector('.tabbed-details__nav')) {
  import('./modules/tabbed-details' as any).then(TabNav => TabNav.default.init());
}

if (document.querySelector('.vehicle-image-carousel')) {
  import('./modules/vehicle-image-carousel' as any).then(VICarousel => VICarousel.init());
}

if (document.querySelector('.card-carousel')) {
  import('./modules/card-carousel' as any).then(CCarousel => CCarousel.init());
}

if (document.querySelector('input[type="range"]')) {
  import('./modules/number-range' as any).then(Range => Range.default.init());
}

if (document.querySelector('#funding-calculator')) {
  import('./modules/funding-calculator' as any).then(Calc => Calc.default.init());
}

if (document.querySelector('.js-datepicker')) {
  import('./modules/datepicker' as any).then(Datepicker => Datepicker.default.init());
}

if (document.querySelector('.js-filter-models')) {
  import('./modules/filter-select' as any).then(fs => fs.default.init());
}

if (document.querySelector('[data-reset-input]')) {
  import('./modules/veho/reset-input' as any).then(ri => ri.default.init());
}

if (document.querySelector('.js-dynamic-text-input')) {
  import('./modules/veho/dynamic-text-input' as any).then(dti => dti.default.init());
}

if (document.querySelector('a[data-formdata-urlifier]')) {
  import('./modules/veho/formdata-urlifier' as any).then(fu => fu.default.init());
}
